import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
  const { completeOAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get('session_id');
    completeOAuth(sid)
      .then(() => {
        toast.success('Connexion Google réussie — bienvenue au labo');
        navigate('/compte', { replace: true });
      })
      .catch(() => {
        toast.error('Connexion Google échouée');
        navigate('/compte', { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grid-bg flex min-h-screen flex-col items-center justify-center gap-4 bg-void" data-testid="auth-callback">
      <Loader2 className="animate-spin text-neon" size={36} />
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-neon">Vérification Google en cours…</p>
    </div>
  );
};

export default AuthCallback;
